import { List, Map } from "immutable"
import { fixMediaUrl, parseMetatagTitle, processRichText } from "../../Shared/api/drupal/drupalApi"
import {
  ParsedNodeActivityClusters,
  ParsedNodeActivityDetail, ParsedNodeBlogOverview, ParsedNodeBlogPost, ParsedNodeCollectionOverview,
  ParsedNodeHome, ParsedNodeLocation, ParsedNodeLocationDetail, ParsedNodeLocationOverview, ParsedNodeNewsItem, ParsedNodeNewsletter, ParsedNodeNewsOverview, ParsedNodePage,
  ParsedNodeReport,
  ParsedNodeReportOverview, ParsedNodeSections,
  ParsedNodeVacancy, ParsedParagraph
} from "../../Shared/api/drupal/types"
import { ActivityClustersPageProps } from "../custom_components/pages/activity_clusters_page"
import { ActivityDetailPageProps } from "../custom_components/pages/activity_detail_page"
import { BlogOverviewProps } from "../custom_components/pages/blogOverview/blogOverviewState"
import { BlogPostProps } from "../custom_components/pages/blogPost/blogPostState"
import { CollectionPageProps } from "../custom_components/pages/collection_page"
import { GeneralContentPageProps } from "../custom_components/pages/general_content_page"
import { HomePageProps } from "../custom_components/pages/home_page"
import { LocationOverviewPageProps } from "../custom_components/pages/Location/LocationOverviewPage/location_overview_page"
import { LocationPageProps } from "../custom_components/pages/Location/LocationPage/LocationPageState"
import { LocationDetailPageDrupalProps } from "../custom_components/pages/location_detail_page"
import { NewsItemProps } from "../custom_components/pages/newsItem/newsItemState"
import { NewsletterSignupPageProps } from "../custom_components/pages/newsletter_signup_page"
import { NewsOverviewProps } from "../custom_components/pages/newsOverview/newsOverviewState"
import { ReportOverviewPageProps } from "../custom_components/pages/report_overview_page"
import { Block } from "./../custom_components/components/block_renderer"
import { Region } from "./api"
import {
  activityClusterBlock,
  booksOverviewBlock,
  buttonBlock, carouselContentGridBlock, collectionBlock, collectionSearchBarBlock, contentGridBlock,
  emptyBlock,
  faqBlock,
  featuredContentBlock, formstackBlock, gridBlock, highlightBlock,
  imagesBlock,
  mediaBlock, pageGridBlock, panoramaBlock, quoteBlock, recentNewsBlock, richTextBlock,
  subscriptionsBlock,
  vacancyOverviewBlock
} from "./drupal_paragraph_to_block"

export const activityClustersPage: (n: ParsedNodeActivityClusters) => ActivityClustersPageProps = n => ({
  kind: "activityClusters",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]),
  imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]),
  phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
  phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
  imageAlt: n.field_media.field_media_image.alt,
  regions: Map<string, Region>(),
  selectedPeriod: null,
  selectedRegion: null,
  selectedCluster: 'none',
  selectPeriod: null,
  selectRegion: null,
  toggleArchive: null,
  showArchive: false,
})

export const activityDetailPage: (n: ParsedNodeActivityDetail) => ActivityDetailPageProps = n => ({
  kind: "activityDetail",
  activityId: n.field_product_db_id,
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  subtitle: n.field_short_description,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: '',
  imageUrlLarge: '',
  phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
  phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
  imageAlt: n.field_media.field_media_image.alt,
  noticeTitle: n.field_notice_title,
  noticeContents: n.field_notice_contents,
  regions: Map<string, Region>(),
  selectedPeriod: null,
  selectedRegion: null,
  selectPeriod: null,
  selectRegion: null,
  blocks: generalContentPageBlocks(n.field_paragraphs),
})

export const collectionPage: (n: ParsedNodeCollectionOverview) => CollectionPageProps = n => ({
  kind: "collection",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: '',
  imageUrlLarge: '',
  phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
  phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
  imageAlt: n.field_media.field_media_image.alt,
  blocks: generalContentPageBlocks(n.field_paragraphs),
})

export const locationDetailPage: (n: ParsedNodeLocationDetail) => LocationDetailPageDrupalProps = n => ({
  kind: "locationDetail",
  locationId: n.field_sharepoint_locatie,
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]),
  imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]),
  phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
  phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
  imageAlt: n.field_media.field_media_image.alt,
  currentTitle: n.field_current_title,
  currentContents: n.field_current_contents ? processRichText(n.field_current_contents) : "",
  aboutTitle: n.field_about_title,
  aboutContents: n.field_about_contents ? processRichText(n.field_about_contents) : "",
  openingHours: n.field_location_opening_hours,
  blocks: generalContentPageBlocks(n.field_paragraphs),
  contactCustomerSupport: n.field_contact_customer_service ? processRichText(n.field_contact_customer_service) : "",
})

export const newsletterSignupPage: (n: ParsedNodeNewsletter) => NewsletterSignupPageProps = n => ({
  kind: "newsletterSignup",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: '',
  imageUrlLarge: '',
  phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
  phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
  imageAlt: n.field_media.field_media_image.alt,
})

export const homePage: (n: ParsedNodeHome) => HomePageProps = n => ({
  kind: "home",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  headerButtonUrl: n.field_header_button_url ? n.field_header_button_url.url : "",
  headerButtonTitle: n.field_header_button_url ? n.field_header_button_url.title : "",
  imageUrl: '',
  imageUrlLarge: '',
  phImageUrlSmall: fixMediaUrl(n.field_media.field_media_image.image.style_urls["624x424"]),
  phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1248x848"]),
  phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["2496x1696"]),
  imageAlt: n.field_media.field_media_image.alt,
  universalBlocks: generalContentPageBlocks(n.field_universal_paragraphs),
  blocks: generalContentPageBlocks(n.field_paragraphs),
  showAnnouncement: n.field_show_announcement,
  announcement: n.field_announcement
})

export const locationPage: (n: ParsedNodeLocation ) => LocationPageProps = n => ({
  kind: "locationContent",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]) : "",
  imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]) : "",
  phImageUrlSmall: n.field_media ? n.field_jumbo_small ? undefined : fixMediaUrl(n.field_media.field_media_image.image.style_urls["624x424"]) : '',
  phImageUrl: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["1248x848"]) : '',
  phImageUrlLarge: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["2496x1696"]) : '',
  imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
  blocks: generalContentPageBlocks(n.field_paragraphs),
  blocks_upper: generalContentPageBlocks(n.field_paragraphs_upper),
  buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
  buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
  jumboSize: n.field_jumbo_small ? "small" : "large",
  locationId: Number(n.field_location_id),
  hideForm: n.field_hide_form ?? false,
})


export const locationOverviewPage: (n: ParsedNodeLocationOverview ) => LocationOverviewPageProps = n => ({
  kind: "locationOverviewContent",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]) : "",
  imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]) : "",
  phImageUrlSmall: n.field_media ? n.field_jumbo_small ? undefined : fixMediaUrl(n.field_media.field_media_image.image.style_urls["624x424"]) : '',
  phImageUrl: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["1248x848"]) : '',
  phImageUrlLarge: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["2496x1696"]) : '',
  imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
  blocks: generalContentPageBlocks(n.field_paragraphs),
  blocks_upper: generalContentPageBlocks(n.field_paragraphs_upper),
  buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
  buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
  jumboSize: n.field_jumbo_small ? "small" : "large",
})

export const generalContentPage: (n: ParsedNodePage | ParsedNodeReport | ParsedNodeSections | ParsedNodeVacancy) => GeneralContentPageProps = n => ({
  kind: "generalContent",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]) : "",
  imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]) : "",
  phImageUrlSmall: n.field_media ? n.field_jumbo_small ? undefined : fixMediaUrl(n.field_media.field_media_image.image.style_urls["624x424"]) : '',
  phImageUrl: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["1248x848"]) : '',
  phImageUrlLarge: n.field_media ? n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["2496x1696"]) : '',
  imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
  blocks: generalContentPageBlocks(n.field_paragraphs),
  buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
  buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
  jumboSize: n.field_jumbo_small ? "small" : "large",
})

export const blogPostPage: (n: ParsedNodeBlogPost) => BlogPostProps = n => ({
  id: n.id,
  kind: "blogPost",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  categories: n.field_blog_category.map(t => ({label: t.label, url: t.url})).toList(),
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]) : "",
  imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]) : "",
  phImageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : "",
  phImageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : "",
  imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
  dateCreated: n.created,
  dateUpdated: n.changed,
  blocks: generalContentPageBlocks(n.field_paragraphs)
})

export const blogOverviewPage: (n: ParsedNodeBlogOverview) => BlogOverviewProps = n => ({
  kind: "blogOverview",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]),
  imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]),
  phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
  phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
  imageAlt: n.field_media.field_media_image.alt,
  pageSize: 6
})

export const newsItemPage: (n: ParsedNodeNewsItem) => NewsItemProps = n => ({
  kind: "newsItem",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]) : "",
  imageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]) : "",
  phImageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : "",
  phImageUrlLarge: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : "",
  imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
  dateCreated: n.created,
  dateUpdated: n.changed,
  blocks: generalContentPageBlocks(n.field_paragraphs)
})

export const newsOverviewPage: (n: ParsedNodeNewsOverview) => NewsOverviewProps = n => ({
  kind: "newsOverview",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]),
  imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]),
  phImageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]),
  phImageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]),
  imageAlt: n.field_media.field_media_image.alt,
  pageSize: 6
})

export const generalContentPageBlocks: (paragraphs: List<ParsedParagraph>) => List<Block> = paragraphs => {
  return List<Block>(
    paragraphs.map(p =>
      p.bundle == "text"
        ? richTextBlock(p)

      : p.bundle == "media"
        ? mediaBlock(p)

      : p.bundle == "faq_collection"
        ? faqBlock(p)

      : p.bundle == "highlight"
        ? highlightBlock(p)

      : p.bundle == "knop"
        ? buttonBlock(p)

      : p.bundle == "images"
        ? imagesBlock(p)

      : p.bundle == "content_grid"
        ? contentGridBlock(p)

      : p.bundle == "caroussel"
        ? carouselContentGridBlock(p)

      : p.bundle == "collection"
        ? collectionBlock(p)

      : p.bundle == "subscription_block"
        ? subscriptionsBlock(p)

      : p.bundle == "books"
        ? booksOverviewBlock(p)

      : p.bundle == "vacancy_overview"
        ? vacancyOverviewBlock(p)

      : p.bundle == "featured_content"
        ? featuredContentBlock(p)

      : p.bundle == "activity_cluster"
        ? activityClusterBlock(p)

      : p.bundle == "quote"
        ? quoteBlock(p)

      : p.bundle == "collection_search_bar"
        ? collectionSearchBarBlock(p)

      : p.bundle == "page_grid"
        ? pageGridBlock(p)

      : p.bundle == "grid_block"
        ? gridBlock(p)

      : p.bundle == "recent_news"
        ? recentNewsBlock(p)

        : p.bundle == "formstack_block"
        ? formstackBlock(p)

        : p.bundle == "panorama"
        ? panoramaBlock(p)

        : emptyBlock(p)
    )
  )
}

export const reportOverview: (n: ParsedNodeReportOverview) => ReportOverviewPageProps = n => ({
  kind: "reportOverview",
  pageTitle: parseMetatagTitle(n.metatag),
  headerTitle: n.field_header_title,
  description: n.field_description ? processRichText(n.field_description) : "",
  imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["420x320_cropped"]),
  imageUrlLarge: fixMediaUrl(n.field_media.field_media_image.image.style_urls["840x640_cropped"]),
  phImageUrlSmall: n.field_jumbo_small ? undefined : fixMediaUrl(n.field_media.field_media_image.image.style_urls["624x424"]),
  phImageUrl: n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["440x440"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["1248x848"]),
  phImageUrlLarge: n.field_jumbo_small ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["880x880"]) : fixMediaUrl(n.field_media.field_media_image.image.style_urls["2496x1696"]),
  imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
  jumboSize: n.field_jumbo_small ? "small" : "large",
  buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
  buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
})
